<template>
  <v-dialog v-model="dialog" width="450" persistent>
    <v-card class="import-coming-soon py-10">
      <div class="d-flex flex-column ">
        <v-btn class="align-self-end mx-3" icon @click="$emit('close-no-client-modal', true)">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </div>
      <v-row class="no-gutters fill-height">
        <v-col :xs="6" :sm="6" :md="6" :lg="6" align="center" class="fill-height margin-auto">
          <v-row justify="center">
            <span class="font-weight-black font-weight-italic fs-20">
              Please add clients first
            </span>
          </v-row>
          <v-row justify="center" class="pt-4">Click here to Add Clients </v-row>
          <v-row justify="center" class="my-2">
            <v-btn
              color="button-primary"
              class="white--text"
              @click="$router.push({ name: 'dashboard.clients', params: { newClient: 'new' } })"
            >
              <span class="font-weight-bold fs-15">Move to Clients </span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "NoClientModal",
  components: {
    // GauravImpexLogo
  },
  data() {
    return {
      dialog: true
    };
  },
  mixins: [commonMethodsMixin],
  methods: {}
};
</script>
<style lang="scss">
.login-container {
  margin: auto;

  .description {
    font-size: 1.3rem;
    font-weight: 600;
  }

  .form-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.import-coming-soon .margin-auto {
  margin: auto;
}
</style>
